import { ApolloCache, FetchResult, MutationResult, useMutation } from '@apollo/client';

import {
  evictCache,
  UpdatePayrollExpenseInput,
  UpdatePayrollExpenseMutation,
  UpdatePayrollExpenseMutationVariables,
  UPDATE_PAYROLL_EXPENSE,
} from '@neo.tax/shared';

type UseUpdatePayrollExpense = [
  (
    payrollExpenseId: string,
    updatePayrollExpenseInput: UpdatePayrollExpenseInput,
  ) => Promise<FetchResult<UpdatePayrollExpenseMutation>>,
  MutationResult<UpdatePayrollExpenseMutation>,
];

const UPDATE_PAYROLL_EXPENSE_REQUEST_KEY = 'UPDATE_PAYROLL_EXPENSE_REQUEST_KEY';

export const useUpdatePayrollExpense = (): UseUpdatePayrollExpense => {
  const [updatePayrollExpenseMutation, updatePayrollExpenseMutationResult] = useMutation<
    UpdatePayrollExpenseMutation,
    UpdatePayrollExpenseMutationVariables
  >(UPDATE_PAYROLL_EXPENSE, {
    context: {
      serializationKey: UPDATE_PAYROLL_EXPENSE_REQUEST_KEY,
      debounceKey: UPDATE_PAYROLL_EXPENSE_REQUEST_KEY,
      errorToast: {
        title: 'Error updating expense',
        description: 'Something unexpected prevented your changes from saving. Please try again.',
      },
    },
  });

  const updatePayrollExpense = (
    payrollExpenseId: string,
    updatePayrollExpenseInput: UpdatePayrollExpenseInput,
  ): Promise<FetchResult<UpdatePayrollExpenseMutation>> =>
    updatePayrollExpenseMutation({
      variables: {
        payrollExpenseId: payrollExpenseId,
        input: updatePayrollExpenseInput,
      },
      update: (cache: ApolloCache<UpdatePayrollExpenseMutation>): void => {
        //invalidate getPayrollQreSummary cache
        evictCache(cache, ['getPayrollQreSummary']);
      },
    });

  return [updatePayrollExpense, updatePayrollExpenseMutationResult];
};
